import $ from 'jquery'
import Cookie from 'js-cookie'

class BlockAlertModal extends window.HTMLDivElement {
  constructor () {
    super()
    this.$ = $(this)
    this.resolveElements()
    this.initEvents()

    if ( Cookie.get('alert-modal-display') != 0 ){
      this.displayAlertModal();
    }

  }

  resolveElements () {
    this.$alertModal = $(this);
    this.$alertModalDismiss = $('.alert-modal__dismiss', this);
  }

  initEvents () {
    this.$alertModalDismiss.click(this.dismissAlertModal.bind(this));
    this.displayAlertModal = this.displayAlertModal.bind(this);
  }

  displayAlertModal(){
    this.$alertModal.fadeIn();
  }

  dismissAlertModal(){
    this.$alertModal.fadeOut();
    Cookie.set('alert-modal-display', '0', { expires: 1 });
  }
}

window.customElements.define('flynt-block-alert-modal', BlockAlertModal, {extends: 'div'})



// WEBPACK FOOTER //
// ./Components/BlockAlertModal/script.js